module.exports = __webpack_public_path__ + "58837ff0e6319b18ffdd451a7e2a7ed9.svg";